export function hogefn() {
    console.log('hogefn');
}
